/* eslint-disable promise/param-names */
const state = {
  modal_rdp:{
      link_rdp: '',
      link_rci: '',
      technique_id: '',
      id_rdp: '',
      report_number: '',
      plant: '',
      area: ''
  }
}

const getters = {
  modal_rdp: state => state.modal_rdp,
}

const mutations = {
    changeModal(state, payload){
        state.modal_rdp = payload;
    }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/modal_rdp.js